import React from 'react'
import { useOrderStore } from 'src/hooks/order';
import System from "../../../../../helper/system";
import { useEffect } from 'react';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Helper from 'src/support/Helper';

const OrderInfoListing = () => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ header_order_detail }, { fetch_header_order_detail }, { order_download_single_invoice }] = useOrderStore();
    useEffect(() => {
        async function fetchHere() {
            await getHeaderOrderDetail()
        }

        fetchHere()
    }, []);

    const getHeaderOrderDetail = async () => {
        await fetch_header_order_detail({
            orderNumber: System.getParams().order_number
        })
    }

    const downloadSingleInvoice = async (invoiceNumber) => {
        await order_download_single_invoice({ invoiceNumber: invoiceNumber })
    }

    const getTrackingCarrierLink = (orderDetail,trackingNumber) => {
        if(orderDetail!==undefined && orderDetail!==null && 
            orderDetail.carrier!==undefined &&
            orderDetail.carrier!==null &&
            Object.keys(orderDetail.carrier).length > 0)
            {
                let trackingCarrier = orderDetail.carrier[trackingNumber];
                if(trackingCarrier!==undefined && trackingCarrier!==null)
                {
                    let carrier=  Helper.getTrackingCarrier(trackingCarrier.carrier); // considering first item carrier
                    if(carrier !== '')
                    {
                        const link = document.createElement('a');
                        link.href = carrier+trackingNumber;
                        link.target = '_blank';
                        link.click();   
                    }
                }
            }
        return false;
    }
    return (
        <>
            {__check(['ORDER_HEADER_DETAIL_API_CALL']).render}
            {
                !__check(['ORDER_HEADER_DETAIL_API_CALL']).status &&
                header_order_detail !== undefined &&
                Object.keys(header_order_detail).length > 0 &&

                <div className="order-information-wrapper">
                    <div className="order-information container-fluid maxw100 ">
                        <h4 className="heading mt-4 mb-0 font-18">Order Information</h4>
                        <div className="bs5 row order-information-row">
                            <div className="col-6 col-md-6 col-lg-3">
                                <div><strong className="text-black">P.O. Number </strong></div>
                                <div>
                                    {header_order_detail.purchaseOrderNumber && header_order_detail.purchaseOrderNumber.trim() !== '' ? header_order_detail.purchaseOrderNumber : '-'}
                                    <input type="hidden" id="purchaseOrderNumber" />
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3">
                                <div><strong className="text-black">Web Order Number</strong></div>
                                <div>{header_order_detail.webOrderNumber && header_order_detail.webOrderNumber.trim() !== '' ? header_order_detail.webOrderNumber : '-'}</div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3">
                                <div><strong className="text-black">Order Number</strong></div>
                                <div>{header_order_detail.sapOrderNumber && header_order_detail.sapOrderNumber.trim() !== '' ? header_order_detail.sapOrderNumber : '-'}</div>
                                <input type="hidden" id="webOrmOrder" />
                            </div>
                            <div className="col-6 col-md-6 col-lg-3">
                            </div>
                        </div>
                        <div className="bs5 row order-information-row bg-grey pb-2">
                            <div className="col-6 col-md-6 col-lg-3 ">
                                <div className="head"><i className="fa fa-user" aria-hidden="true" /> Buyer Contact Information</div>
                                <div className="head-desc">
                                    <div>{header_order_detail.buyerName && header_order_detail.buyerName.trim() !== '' ? header_order_detail.buyerName : '-'}</div>
                                    <div>{header_order_detail.buyerEmail && header_order_detail.buyerEmail.trim() !== '' ? header_order_detail.buyerEmail : ''}</div>
                                    <div>{header_order_detail.buyerContact && header_order_detail.buyerContact.trim() !== '' ? header_order_detail.buyerContact : ''}</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 ">
                                <div className="head"><i className="fa fa-tag" aria-hidden="true" /> Billing Address</div>
                                <div id="ord_details_billing">

                                    <input type="hidden" name="addressId" defaultValue={3074457345617588427} id="Addr_AddressId" data-di-id="#Addr_AddressId" />
                                    <input type="hidden" name="Country" defaultValue="US" id="Addr_Country_3074457345617588427" data-di-id="#Addr_Country_3074457345617588427" />
                                    <div className="head-desc">
                                        {
                                            header_order_detail.billingAddress && Object.entries(header_order_detail.billingAddress).length > 0 &&
                                            <>
                                                <div> {header_order_detail.billingAddress.name}</div>
                                                <div>{header_order_detail.billingAddress.street}</div>
                                                <div>
                                                    {header_order_detail.billingAddress.city} {header_order_detail.billingAddress.postCode}
                                                </div>
                                                <div>{header_order_detail.billingAddress.land}</div>
                                            </>
                                        }
                                    </div>
                                </div>
                                <p />
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 ">
                                <div className="head"><i className="fa fa-truck" aria-hidden="true" /> Shipping Address</div>
                                <div id="ordDetailShipAddr">

                                    <div className="field">
                                        <div className="head-desc">
                                            {
                                                header_order_detail.shippingAddress && Object.entries(header_order_detail.shippingAddress).length > 0 &&
                                                <>
                                                    <div> {header_order_detail.shippingAddress.name}</div>
                                                    <div>{header_order_detail.shippingAddress.street}</div>
                                                    <div>
                                                        {header_order_detail.shippingAddress.city} {header_order_detail.shippingAddress.postCode}
                                                    </div>
                                                    <div>{header_order_detail.shippingAddress.land}</div>
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 ">
                                <div className="head"><i className="fa fa-truck" aria-hidden="true" />Shipping Method</div>
                                <div>
                                    <div className="head-desc">
                                        <div>{header_order_detail.shippingMethod && header_order_detail.shippingMethod.trim() !== '' ? header_order_detail.shippingMethod : 'Avnet Standard Carrier'}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <input type="hidden" defaultValue={492830541} name="toonhashcode" id="toonhashcode" data-di-id="#toonhashcode" />
                        <div className="bs5 row order-information-row p-0
                                ">
                            <div className="col-6 col-md-6 col-lg-3 border-right py-2">
                                <div className="head">Invoice</div>

                                <input type="hidden" id="invoiceData" defaultValue="[com.avnet.dx.order.vo.AvnOrderInvoiceVO@b0112614]" data-di-id="#invoiceData" />
                                {header_order_detail.invoice && header_order_detail.invoice.length > 0 ?
                                    <>
                                        {header_order_detail.invoice.map((v, i) => {
                                            if (i < 2) {
                                                return <div className="mb-2">
                                                    <i className="fa fa-download me-1" aria-hidden="true" />
                                                    <a href={void (0)} aria-label="InvoiceGenerationlink"
                                                        onClick={() => downloadSingleInvoice(v)}>{v} </a>
                                                    <input type="hidden" id="invoiceUrlGeneration1" />
                                                </div>
                                            }
                                        })}
                                        {
                                            header_order_detail.invoice.length > 2 &&

                                            <div className="mb-2">
                                                <a href={void (0)} aria-label="InvoiceGenerationlink" data-toggle="modal" data-target="#ViewAllInvoices" onClick={() => {
                                                    System.popup('OrderDetailViewInvoicesPopup', {
                                                        invoiceData: header_order_detail.invoice,
                                                        poNumber: header_order_detail.purchaseOrderNumber
                                                    });
                                                }}>View All Invoices </a>
                                            </div>
                                        }
                                    </> :
                                    '-'
                                }
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 border-right py-2">
                                <div className="head">Tracking/Waybill Number </div>
                                {header_order_detail.trackingNumber && header_order_detail.trackingNumber.length > 0 ?
                                    <div id="tracking_55640725">
                                        {header_order_detail.trackingNumber.map((v, i) => {
                                            if (i < 2) {
                                                return <a href={void (0)} onClick={() => getTrackingCarrierLink(header_order_detail, v)} className="d-block mb-2" >{v}</a>
                                            }
                                        })}
                                        {
                                            header_order_detail.trackingNumber.length > 2 &&

                                            <div className="mb-2">
                                                <a href={void (0)} className="d-block mb-2" data-toggle="modal" data-target="#ViewAllTracking" onClick={() => {
                                                    System.popup('OrderDetailViewAllTrackingPopup', {
                                                        trackingData: header_order_detail.trackingNumber,
                                                        poNumber: header_order_detail.purchaseOrderNumber,
                                                        header_order: header_order_detail
                                                    });
                                                }}>View All Tracking</a>
                                            </div>
                                        }
                                    </div> :
                                    '-'
                                }
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 border-right py-2">
                                <div className="head">Payment Method</div>
                                <div className="bs5 row padding0">
                                    <div className="col-sm-12">
                                        <div><strong className="text-black">Terms Account Information</strong></div>
                                        <div>
                                            <div>{header_order_detail.customerAccountNumber && header_order_detail.customerAccountNumber.trim() !== '' ? header_order_detail.customerAccountNumber : '-'}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 py-2">
                                <div className="head">Additional Information</div>
                                <div className="bs5 row padding0">
                                    <div className="col-sm-12 col-md-6">
                                        <div><strong className="text-black">Order Type</strong></div>
                                        <div>
                                            {header_order_detail.orderType && header_order_detail.orderType.trim() !== '' ? header_order_detail.orderType : '-'}
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-lg-6">
                                        <div><strong className="text-black">Order Date</strong></div>
                                        <div>
                                            {header_order_detail.finalOrderDate && header_order_detail.finalOrderDate.trim() !== '' ? header_order_detail.finalOrderDate : '-'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }

        </>
    )
}

export default OrderInfoListing